import * as React from "react";
import { IftPayoutDeatils } from "../../../types/components/fundTransfer/ftTypes";
import { FtCircledIcon } from "../generic/ftCircleOIcon";
import { EdLinkButton } from "../../../generic/edButton";

interface IFtPayOutPendingProps {
	data: IftPayoutDeatils;
	asset: string;
}

const FtPayOutPending: React.FunctionComponent<IFtPayOutPendingProps> = (props) => {
	const linkToHist = "./history/" + props.asset.toLowerCase() + "/withdrawn";
	return (
		<div className="pendingPayout taCenter">
			<FtCircledIcon style={{ width: "150px", height: "150px", backgroundColor: "#f2f5fc" }} />
			<p className="pendingMsg pd-t15">{props.data.pendingMsg}</p>
			<p className="mg-t30">
				<EdLinkButton className="modifyPayoutLink" value="Modify request" btnTyp="blue-link" LinkHref={linkToHist} />
			</p>
		</div>
	);
};

export default FtPayOutPending;
